import { Box, Button, Divider, InputAdornment, Paper, TextField, Tooltip, Typography } from '@mui/material';
import { getPromocodesValidate } from 'api/thunk/promoCodes/getActions/getPromocodesValidate';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'shared/config/configureStore';
import { useAppSelector } from 'shared/lib/hooks/hooks';

interface IPromoCodeProps {
  setEnteredPromocode: (value: string) => void;
  enteredPromocode: string;
}

const PromoCode: FC<IPromoCodeProps> = ({
  setEnteredPromocode,
  enteredPromocode,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const distanceId = useAppSelector(
    (state) => state.marathons.marathonsById.params.distance
  );

  const handleEnteredPromocodeChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = e.target.value;
    setEnteredPromocode(value);
  };

  const handleApplyPromo = useCallback(() => {
    if (!distanceId || !enteredPromocode) return;

    dispatch(getPromocodesValidate({
      distanceId: Number(distanceId),
      code: enteredPromocode,
    }));
  }, [enteredPromocode, distanceId, dispatch]);

  return (
    <Paper
      sx={{
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "none",
      }}
    >
      <Box
        display="flex"
        columnGap="16px"
        paddingBottom="16px"
      >
        <Typography
          sx={{ fontSize: "20px", fontWeight: 600, marginBottom: "16px" }}
        >
          {t("registerToMarathon.promocode")}
        </Typography>
        <Divider
          sx={{
            flexGrow: 1,
            height: "1px",
            my: 2,
            backgroundColor: "#ECF2F7",
          }}
        />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
      >
        <TextField
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              height: "40px",
            },
            "& .MuiInputBase-input": {
              padding: "10px 14px",
              height: "40px",
            },
          }}
          variant="outlined"
          fullWidth
          disabled={!distanceId}
          value={enteredPromocode}
          onChange={handleEnteredPromocodeChange}
          // error={Boolean(error && enteredPromocode !== "")}
          // helperText={
          //   enteredPromocode !== "" && PaymentsValidatesErrorMessage
          // }
          InputProps={{
            placeholder: t("myMarathon.enterCode"),
            endAdornment: (
              <InputAdornment position="end">
                {!distanceId ? (
                  <Tooltip
                    title={
                      !distanceId
                        ? t("myMarathon.registerToMarathon.selectDistance")
                        : t(
                          "myMarathon.registerToMarathon.promocodeAlreadySelected"
                        )
                    }
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#1976d2",
                          color: "#fff",
                          fontSize: "14px",
                          borderRadius: "8px",
                          padding: "8px 12px",
                          cursor: "pointer",
                        },
                      },
                      arrow: {
                        sx: {
                          color: "#1976d2",
                        },
                      },
                    }}
                  >
                    <span>
                      <Button
                        size="small"
                        sx={{
                          height: "32px",
                          borderRadius: "8px",
                          textTransform: "none",
                          fontSize: "14px",
                        }}
                        disabled
                      >
                        {t("myMarathon.registerToMarathon.apply")}
                      </Button>
                    </span>
                  </Tooltip>
                ) : (
                  <Button
                    size="small"
                    sx={{
                      height: "32px",
                      borderRadius: "8px",
                      textTransform: "none",
                      fontSize: "14px",
                    }}
                    onClick={handleApplyPromo}
                  >
                    {t("myMarathon.registerToMarathon.apply")}
                  </Button>
                )}
              </InputAdornment>
            ),
          }}
        />
        {/* {isPromoCodeApplied && enteredPromocode !== "" && (
              <Typography
                sx={{
                  color: "green",
                  marginTop: "2px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  padding: "8px",
                  fontSize: "12px",
                }}
              >
                {t("myMarathon.registerToMarathon.success")}
              </Typography>
            )} */}
      </Box>
    </Paper>
  );
};

export default PromoCode;